/**
 * R7.2.2C — Customer search outcome contract.
 */
export type SearchOutcomeKind =
  | "RESULTS"
  | "NO_EXACT_RESULTS_WITH_ALTERNATIVES"
  | "TRUE_NO_RESULT"
  | "TEMPORARY_TECHNICAL_ERROR";

export function deriveSearchOutcome(input: {
  ok?: boolean;
  hits?: unknown[];
  total?: number;
  correction?: string | null;
  did_you_mean?: string | null;
  error?: string;
}): SearchOutcomeKind {
  if (input.ok === false || input.error) return "TEMPORARY_TECHNICAL_ERROR";
  const total = input.total ?? input.hits?.length ?? 0;
  if (total > 0) return "RESULTS";
  if (input.correction || input.did_you_mean) return "NO_EXACT_RESULTS_WITH_ALTERNATIVES";
  return "TRUE_NO_RESULT";
}

export function isLikelyBarcodeQuery(raw: string): boolean {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return false;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length < 8 || digits.length > 14) return false;
  const compact = trimmed.replace(/\s/g, "");
  return digits.length >= compact.length * 0.85;
}

export function normalizeBarcodeDigits(raw: string): string {
  return String(raw ?? "").replace(/\D/g, "");
}
